'use client';

import { ComponentBlock } from '@modules/prism-client/types/types';
import { useClientTranslation } from '@lib/i18n/client';
import { HeaderSection, type HeaderSectionProps } from '@tuic/web-compositions/shared/HeaderSection';
import { UniversalCarousel, CarouselStage, CarouselDefaultPagination } from '@tuic/web-compositions/shared/UniversalCarousel';
import { ContentCardBlock, ContentCardBlockData } from '../ContentCard/ContentCardBlock';
import { getI18nForPagination } from '@lib/i18n-sets';
import { twMerge } from '@tuic/tailwind-config';
export type CarouselData = {
  header: HeaderSectionProps;
  cards: ContentCardBlockData[];
  maxAmountPerPage: 1 | 2 | 3;
};
export const CarouselBlock: ComponentBlock<CarouselData> = ({
  data,
  fallback
}) => {
  const {
    t
  } = useClientTranslation();
  if (!data) return null;
  return <div className="space-y-6" data-sentry-component="CarouselBlock" data-sentry-source-file="CarouselBlock.tsx">
      <HeaderSection {...data.header} fallback={fallback} data-sentry-element="HeaderSection" data-sentry-source-file="CarouselBlock.tsx" />
      <UniversalCarousel data-sentry-element="UniversalCarousel" data-sentry-source-file="CarouselBlock.tsx">
        <CarouselStage className="carousel-stage-gap-2 md:carousel-stage-gap-6" itemProps={{
        className: twMerge('carousel-item-w-full', data.maxAmountPerPage >= 2 && 'md:carousel-item-w-1/2', data.maxAmountPerPage >= 3 && 'lg:carousel-item-w-1/3')
      }} data-sentry-element="CarouselStage" data-sentry-source-file="CarouselBlock.tsx">
          {data.cards.map((card, index) => <ContentCardBlock key={index} data={card} fallback={fallback} />)}
        </CarouselStage>
        <CarouselDefaultPagination i18n={getI18nForPagination(t)} data-sentry-element="CarouselDefaultPagination" data-sentry-source-file="CarouselBlock.tsx" />
      </UniversalCarousel>
    </div>;
};